module.exports = __webpack_public_path__ + "img/smile-beam.55f13bbf.svg";